import { withDefaultContextAsSelectedProject } from './api-default-context';
import { getStatementIdUtil } from 'utils/statement-export-utils';

export const getRevisionsSectionsRequest = ({
  statementId,
  revisionId,
  onlyBookmarkSection = true,
  asTreeList = false,

  // for pages like side by side, we want to fetch section values for different (other than selected project) project,
  // hence we can pass context key and context value to make api call in desired project geo.

  // If context key is not passed, then by default call will be made in selected project geo
  contextKeyForApiCall,
  contextValue,
}) =>
  withDefaultContextAsSelectedProject({
    contextKey: contextKeyForApiCall,
    contextValue,
  }).get(
    `/tieout/statements/${getStatementIdUtil(
      statementId,
    )}/revisions/${revisionId}/sections`,
    {
      params: {
        bookmarkSection: onlyBookmarkSection ? 1 : 0,
        treeList: asTreeList ? 1 : 0,
      },
    },
  );

export const getRevisionsSectionsOCRRequest = ({
  statementId,
  revisionId,
  onlyBookmarkSection = true,
  asTreeList = false,

  // for pages like side by side, we want to fetch section values for different (other than selected project) project,
  // hence we can pass context key and context value to make api call in desired project geo.

  // If context key is not passed, then by default call will be made in selected project geo
  contextKeyForApiCall,
  contextValue,
}) =>
  withDefaultContextAsSelectedProject({
    contextKey: contextKeyForApiCall,
    contextValue,
  }).get(
    `/tieout/statements/${getStatementIdUtil(
      statementId,
    )}/revisions/${revisionId}/bookmarks`,
    {
      params: {
        bookmarkSection: onlyBookmarkSection ? 1 : 0,
        treeList: asTreeList ? 1 : 0,
      },
    },
  );

export const updateRevisionsSectionRequest = (
  revisionId,
  sectionId,
  sectionName,
  entity,
  bookmarkId,
  isOCR,
) => {
  const URL = isOCR
    ? `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/bookmark/update`
    : `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/section`;

  const payloadObj = {
    entity: entity,
  };

  payloadObj[isOCR ? 'bookmarkId' : 'sectionId'] = isOCR
    ? bookmarkId
    : sectionId;
  payloadObj[isOCR ? 'bookmarkName' : 'sectionName'] = sectionName;

  return withDefaultContextAsSelectedProject().post(URL, payloadObj);
};

export const deleteRevisionsSectionRequest = (
  revisionId,
  sectionId,
  sectionName,
  sectionReviewed,
  isOCR,
) => {
  const URL = isOCR
    ? `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/bookmark/delete`
    : `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/section/delete`;

  const payloadObj = {};

  payloadObj[isOCR ? 'bookmarkId' : 'sectionId'] = sectionId;
  payloadObj[isOCR ? 'bookmarkName' : 'sectionName'] = sectionName;
  payloadObj[isOCR ? 'bookmarkReviewed' : 'sectionReviewed'] = sectionReviewed;

  return withDefaultContextAsSelectedProject().post(URL, payloadObj);
};

export const reviewSectionRequest = (
  revisionId,
  sectionId,
  isSectionAlreadyReviewed,
  isOCR,
) => {
  const URL = !isOCR
    ? `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/sections/${sectionId}/reviews/add/reviewstatus/${
        isSectionAlreadyReviewed ? 1 : 0
      }`
    : `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/bookmarks/${sectionId}/reviews/add/reviewstatus/${
        isSectionAlreadyReviewed ? 1 : 0
      }`;
  return withDefaultContextAsSelectedProject().post(URL);
};

export const deleteReviewSectionRequest = (
  revisionId,
  sectionId,
  isSectionAlreadyReviewed,
  isOCR,
) => {
  const URL = !isOCR
    ? `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/sections/${sectionId}/reviews/delete/reviewstatus/${
        isSectionAlreadyReviewed ? 1 : 0
      }`
    : `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/bookmarks/${sectionId}/reviews/delete/reviewstatus/${
        isSectionAlreadyReviewed ? 1 : 0
      }`;
  return withDefaultContextAsSelectedProject().post(URL);
};

export const getSectionReviewersRequest = ({
  revisionId,
  contextKey,
  contextValue,
  statementId,
}) =>
  // for side by side page we want to make request in other project than currently selected project, so we need context key and value
  withDefaultContextAsSelectedProject({ contextKey, contextValue }).get(
    `/tieout/statements/${getStatementIdUtil(
      statementId,
    )}/revisions/${revisionId}/reviews`,
  );

export const getSectionReviewersOCRRequest = (
  revisionId,
  contextKey,
  contextValue,
  statementId,
) =>
  // for side by side page we want to make request in other project than currently selected project, so we need context key and value
  withDefaultContextAsSelectedProject({ contextKey, contextValue }).get(
    `/tieout/statements/${getStatementIdUtil(
      statementId,
    )}/revisions/${revisionId}/bookmarkreviews`,
  );

export const getSectionHistoryRequest = ({ revisionId, sectionId, isOCR }) => {
  const URL = isOCR
    ? `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/bookmarks/${sectionId}/history`
    : `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/sections/${sectionId}/history`;
  return withDefaultContextAsSelectedProject().get(URL);
};

export const getSectionAssignments = ({ revisionId, sectionId }) => {
  return withDefaultContextAsSelectedProject().get(
    `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/sections/${sectionId}/assignments`,
  );
};

export const getSectionOCRAssignments = ({ revisionId, bookmarkId }) => {
  return withDefaultContextAsSelectedProject().get(
    `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/bookmarks/${bookmarkId}/assignments`,
  );
};

export const createRevisionSectionAssignment = ({
  revisionId,
  sectionId,
  userIds,
}) => {
  return withDefaultContextAsSelectedProject().post(
    `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/assignments`,
    {
      revisionId: revisionId,
      sectionId: sectionId,
      userIds: userIds,
    },
  );
};

export const createRevisionSectionOCRAssignment = ({
  revisionId,
  bookmarkId,
  userIds,
}) => {
  return withDefaultContextAsSelectedProject().post(
    `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/bookmarkassignments`,
    {
      revisionId,
      bookmarkId,
      userIds,
    },
  );
};

export const getAllSectionAssignments = ({ revisionId, statementId }) => {
  return withDefaultContextAsSelectedProject().get(
    `/tieout/statements/${getStatementIdUtil(
      statementId,
    )}/revisions/${revisionId}/assignments`,
  );
};

export const getAllSectionOCRAssignments = ({ revisionId }) => {
  return withDefaultContextAsSelectedProject().get(
    `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/bookmarkassignments`,
  );
};

export const getElementsCountBySectionID = ({ revisionId, sectionId }) => {
  return withDefaultContextAsSelectedProject().get(
    `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/sections/${sectionId}/summary/elements`,
  );
};

export const getNotesCountBySectionID = ({ revisionId, sectionId }) => {
  return withDefaultContextAsSelectedProject().get(
    `/tieout/statements/${getStatementIdUtil()}/revisions/${revisionId}/sections/${sectionId}/summary/notes`,
  );
};
